module.exports = __webpack_public_path__ + "img/banner1.75743639.png";